import { withTranslatedMeta } from 'i18n/utils'

import { openReservationDetails, closeReservationDetails } from '../actions'
import { selectedReservationSelector } from '../selectors'
import scrollTop from 'shared/scroll-top'

import Reservations from './Reservations'
import ReservationDetails from './ReservationDetails'
import './styles.scss'

class ReservationsView extends Component {
    constructor(props) {
        super(props)

        this.onSelectReservation = this.onSelectReservation.bind(this)
        this.onCloseReservationDetails = this.onCloseReservationDetails.bind(this)

        this.state = {
            previousScrollY: 0,
        }
    }

    onSelectReservation(reservationId) {
        const { openReservationDetails } = this.props

        this.setState(
            {
                previousScrollY: window.scrollY,
            },
            () => {
                scrollTop()
                window.scrollTo(0, 0)
                openReservationDetails(reservationId)
            }
        )
    }

    onCloseReservationDetails() {
        const { previousScrollY } = this.state
        const { closeReservationDetails } = this.props

        this.setState(
            {
                previousScrollY: undefined,
            },
            () => {
                scrollTop(previousScrollY)
                closeReservationDetails()
            }
        )
    }

    render() {
        const { selectedReservationId } = this.props

        return (
            <div className="container reservations-container dashboard-inner-container">
                {selectedReservationId ? (
                    <ReservationDetails
                        reservationId={selectedReservationId}
                        onClose={this.onCloseReservationDetails}
                    />
                ) : (
                    <Reservations onSelectReservation={this.onSelectReservation} />
                )}
            </div>
        )
    }
}

const mapStateToProps = createStructuredSelector({
    selectedReservationId: selectedReservationSelector,
})

export default compose(
    withTranslatedMeta('dashboard.menu.transactions'),
    connect(mapStateToProps, { openReservationDetails, closeReservationDetails })
)(ReservationsView)
